import Promise from 'promise-polyfill'

window.Promise = window.Promise || Promise



// WEBPACK FOOTER //
// ./src/utils/promise-polyfill.js